import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';

const SearchInput = ({ onChange, clearFilter, ...props }) => {
  const [value, setValue] = useState('');
  const handleChange = (event) => {
    const value = event?.target?.value;
    setValue(value);
    onChange(value);
  };

  useEffect(() => {
    if (clearFilter) {
      setValue('');
    }
  }, [clearFilter]);

  return (
    <TextField
      {...props}
      onChange={(e) => handleChange(e)}
      value={value}
      size="medium"
      fullWidth
      sx={{ maxWidth: '13.75rem' }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon color="action" />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchInput;
